"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryReportForClassClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class SummaryReportForClassClient {
    static newInstance(options, retryOptions) {
        return new SummaryReportForClassClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async assessmentsScoreAverageForClass(assessmentsAverageScoreForClassPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.scoreForClass`, assessmentsAverageScoreForClassPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsScoreAverageForClassV2(assessmentsAverageScoreForClassPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.scoreForClass`, assessmentsAverageScoreForClassPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async studentsDistributionByClass(studentsScoreDistributionByClassPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.studentsDistributionByClass`, studentsScoreDistributionByClassPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async studentsDistributionByClassV2(studentsScoreDistributionByClassPayloadDto, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.studentsDistributionByClass`, studentsScoreDistributionByClassPayloadDto, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreOfClassItemWise(payload, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.scoreClassByItem`, payload, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsAverageScoreOfClassItemWiseV2(payload, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/v2/assessments.scoreClassByItem`, payload, {
            headers,
        });
        return response.body.data;
    }
    async assessmentsClassList(payload, headers) {
        const response = await this.client.post(`${sdk_constants_1.AVR_API_PREFIX}/assessments.classList`, payload, {
            headers,
        });
        return response.body.data;
    }
}
exports.SummaryReportForClassClient = SummaryReportForClassClient;
//# sourceMappingURL=summary-report-for-class.client.js.map